/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryUpdate } from '../../models/dto-registry-update';
import { RegistryItem } from '../../models/registry-item';

export interface RegistryControllerUpdate$Params {
  id: number;
      body: DtoRegistryUpdate
}

export function registryControllerUpdate(http: HttpClient, rootUrl: string, params: RegistryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryItem;
      }>;
    })
  );
}

registryControllerUpdate.PATH = '/registry/{id}';
